import { FC, SVGProps } from 'react';

export const EditIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
		<path
			d='M13.6098 19.8321H20.2967M11.096 6.51687L16.1229 10.3773M12.7182 4.48279C13.4334 3.6281 14.7189 3.50277 15.5913 4.20337C15.6396 4.24138 17.1894 5.44534 17.1894 5.44534C18.1478 6.02472 18.4456 7.25642 17.8531 8.19637C17.8217 8.24671 9.05972 19.2067 9.05972 19.2067C8.76821 19.5703 8.32571 19.785 7.8528 19.7901L4.49733 19.8323L3.74131 16.6323C3.6354 16.1824 3.74131 15.7098 4.03281 15.3462L12.7182 4.48279Z'
			stroke='currentColor'
			strokeWidth='2'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);
